(function () {
    'use strict';

    angular
        .module('app')
        .controller('ReplaceDocumentTemplateFileConfirmationCtrl', ReplaceDocumentTemplateFileConfirmationCtrl);

    ReplaceDocumentTemplateFileConfirmationCtrl.$inject = ['DialogInstance', 'showPreservePdfInsertionDetails'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog prompting user to confirm they want to replace the current document template file
     * 
     */
    function ReplaceDocumentTemplateFileConfirmationCtrl(DialogInstance, showPreservePdfInsertionDetails) {
        /* jshint validthis:true */
        var vm = this;
        vm.showPreservePdfInsertionDetails = showPreservePdfInsertionDetails;
        vm.ok = ok;
        vm.cancel = cancel;

        function ok() {
            DialogInstance.ok({
                PreservePdfInsertionDetails: vm.preservePdfInsertionDetails ? vm.preservePdfInsertionDetails : false
            });
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
